import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-inst';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading:false,
    },
    mutations: {
        isLoading(state){
            state.loading=true
        },
        isNotLoading(state){
            state.loading=false
        },   
    },
    actions: {
        
    },
    getters: {
        getLoadingState(state){
            return state.loading
        }
    }
  })


// WEBPACK FOOTER //
// ./src/store.js